import * as React from 'react'
import classNames from 'classnames'
import { TagStyle } from './tag.interfaces'
import './tag.scss'

interface IProps {
  className?: string
  color?: string
  size?: TagSize
  style?: TagStyle
  children: React.ReactNode
}

type TagSize = 'large'

export class Tag extends React.PureComponent<IProps> {
  render(): React.ReactNode {
    const classes = classNames(
      // @TODO: Once legacy tag styles are removed, this can be renamed to tag
      'tag-react',
      this.props.className,
      { [`tag-react--${this.props.size}`]: this.props.size },
      { [`tag-react--${this.props.style}`]: this.props.style }
    )

    const styles: React.CSSProperties = {
      backgroundColor: this.props.color ? this.props.color : '#000'
    }

    return (
      <span className={classes} style={styles}>
        {this.props.children}
      </span>
    )
  }
}
